import React, { useState, useEffect } from "react";
import Select from "react-select";
import { CDBBtn } from 'cdbreact';

export const ModalReceptions = ({
  action,
  setPressedButton,
  formData,
  handleChange,
  skus,
}) => {

  const skusSelect = skus.map((sku) => ({
    value: `${sku.Nit}/*-/${sku.CodeSap}`,
    label: `${sku.Nit} - ${sku.CodeSap} - ${sku.SkuDescription}`,
  }));

  const renderFormField = (label, id, placeholder, disabled, value, onChange) => (
    <div className="form-group">
      <label>{label}<span className="text-danger"> *</span></label>
      <input
        type="text"
        className="form-control mb-4"
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={onChange}
      />
    </div>
  );

  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === 'create' ? 'Crear una recepción' : 'Editando una recepción'}
          </h3>
        </div>
        {action === 'edit' && (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => setPressedButton('delete')}
          >
            <i className="fas fa-trash"></i>
            Eliminar Recepción
          </CDBBtn>
        )}
      </div>
      <div className="modal-body">
        {action !== 'create' && renderFormField(
          "Número del lote:",
          "LotNumber",
          "Número del lote",
          true,
          formData.LotNumber,
          handleChange
        )}
        {action !== 'edit' && renderFormField(
          "Número del lote:",
          "LotNumber",
          "Número de lote",
          false,
          formData.LotNumber,
          handleChange
        )}
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="selectCodeSap">Código SAP:<span className="text-danger"> *</span></label>
            <Select
              id="selectCodeSap"
              placeholder="Seleccione un Código SAP"
              isDisabled={action === 'edit'}
              options={skusSelect}
              value={skusSelect.find(
                (option) => option.value === `${formData.Nit}/*-/${formData.CodeSap}`
              )}
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    value: selectedOption.value,
                    id: "CodeSap",
                  },
                })
              }
            />
          </div>
        </div>
        {["UnitsReception", "UnitsDefective", "ReceptionsDescription"].map(field => (
  <div className="form-group" key={field}>
    <label htmlFor={field}>
      {fieldLabels[field]}
      {field !== "ReceptionsDescription" && <span className="text-danger"> *</span>}
    </label>
    {field === "ReceptionsDescription" ? (
      <textarea
        className="form-control mb-4"
        id={field}
        placeholder={fieldLabels[field]}
        value={formData[field]}
        onChange={handleChange}
      />
    ) : (
      <input
        type="number"
        className="form-control mb-4"
        id={field}
        placeholder={fieldLabels[field]}
        value={formData[field]}
        onChange={handleChange}
      />
    )}
  </div>
))}
      </div>
      <div className="modal-footer justify-content-center align-items-center">
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton('closeModal')}
        >
          Cerrar
        </CDBBtn>
        <CDBBtn
          type="button"
          color="success"
          className="mr-auto"
          outline
          onClick={() => setPressedButton('submitModal')}
        >
          Guardar
        </CDBBtn>
      </div>
    </div>
  );
};

const fieldLabels = {
  UnitsReception: "Unidades recibidas",
  UnitsDefective: "Unidades defectuosas",
  ReceptionsDescription: "Descripción",
};